import { isContextValid } from './utilities/validation-utils.js';
import { extractUserAuthCode, getWebUrlForEnvironment } from './utilities/init-utils.js';
import { logSDKInit } from './utilities/event-utils.js';
import { SDKEnvironmentType } from './types/SDKEnvironmentType.js';
const april = {
    _iframeUrlListener: null,
    startApril: async function (aprilContext, onExit, onError) {
        if (!isContextValid(aprilContext.applicationContext, onError)) {
            return;
        }
        const userAuthCode = extractUserAuthCode(aprilContext.applicationContext.authToken, onError);
        if (!userAuthCode) {
            return;
        }
        const url = getWebUrlForEnvironment(aprilContext.applicationContext.sdkEnvironment);
        const authenticatedUrl = `${url}?userAuthCode=${userAuthCode}`;
        await logSDKInit(aprilContext.applicationContext);
        if (aprilContext.renderInElement === null || aprilContext.renderInElement === undefined) {
            // If an element is not provided, open april in a new tab
            window.open(authenticatedUrl, '_blank');
        }
        else if (aprilContext.renderInElement && typeof aprilContext.renderInElement === 'string') {
            // Handle updating the actual tag
            const targetElement = document.querySelector(aprilContext.renderInElement);
            if (!targetElement) {
                throw new Error(`Cannot start aprilSDK, target tag '${aprilContext.renderInElement}' was not found`);
            }
            else {
                targetElement.innerHTML = '';
                const iframe = document.createElement('iframe');
                iframe.name = 'april-taxes';
                iframe.id = 'april-taxes';
                iframe.src = authenticatedUrl;
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.border = 'none';
                targetElement.appendChild(iframe);
                this._iframeUrlListener = (event) => {
                    if (event.data && event.data.type === 'exitApril') {
                        targetElement.innerHTML = '';
                        onExit === null || onExit === void 0 ? void 0 : onExit();
                        april._clearListeners();
                    }
                };
                window.addEventListener('message', this._iframeUrlListener);
            }
        }
        else {
            // Raise an error about invalid element
            throw new Error(`Cannot start aprilSDK, invalid tag provided '${aprilContext.renderInElement}', string 'selector' expected`);
        }
    },
    _clearListeners: function () {
        if (this._iframeUrlListener) {
            window.removeEventListener('message', this._iframeUrlListener);
            this._iframeUrlListener = null;
        }
    },
};
const startApril = (aprilContext, onExit, onError) => {
    april.startApril(aprilContext, onExit, onError);
};
export { SDKEnvironmentType };
export default startApril;
